// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uiLs0O1O8N8uih {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.spOlzjRqXiqkx4 {
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: var(--ds-font-weight-medium, 500);
}
.Da7YzN7_cC1R1S {
  margin-bottom: 16px;
}
.fSiezk7TthM0PD {
  background-color: var(--ds-background-accent-purple-subtler, #dfd8fd);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyState": `uiLs0O1O8N8uih`,
	"emptyStateHeader": `spOlzjRqXiqkx4`,
	"emptyStateText": `Da7YzN7_cC1R1S`,
	"emptyStateBusinessClassButton": `fSiezk7TthM0PD`
};
export default ___CSS_LOADER_EXPORT___;
